export type Role = 'SuperAdmin' | 'Admin' | 'Viewer';

export interface AuthenticatedUser {
  id: string;
  email: string;
  fullName: string;
  role: Role;
}

export interface AuthContextValue {
  user: AuthenticatedUser | null;
  isAuthenticated: boolean;
  isBootstrapping: boolean;
  login: (email: string, password: string) => Promise<AuthLoginError | null>;
  logout: () => Promise<void>;
  refresh: () => Promise<string | null>;
}

export type AuthLoginError =
  | { kind: 'invalid_credentials'; message: string }
  | { kind: 'lockout'; message: string }
  | { kind: 'account_disabled'; message: string }
  | { kind: 'network'; message: string };

export const RoleRank: Record<Role, number> = {
  Viewer: 1,
  Admin: 2,
  SuperAdmin: 3,
};
